import VLegend from './VLegend.vue';
import VLegendItem from './VLegendItem.vue';

export {VLegend, VLegendItem};
export default {VLegend, VLegendItem};
